<template>
  <div v-show="show" class="lb-table-action-row">
    <span class="lb-table-action-row__report">
      <slot name="report">
        {{
          $t('ADVERTISEMENT.KEYWORDPLANNER.SELECTED_KEYWORDS', {
            count,
          })
        }}
      </slot>
    </span>
    <div class="lb-table-action-row__divider" />

    <slot />

    <ElButton
      class="lb-table-action-row__close"
      type="text"
      icon="el-icon-close"
      @click="close"
    />
  </div>
</template>

<script>
export default {
  name: 'LbTableActionRow',
  model: {
    prop: 'show',
    event: 'close',
  },
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    count: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    close() {
      this.$emit('close', false);
    },
  },
};
</script>

<style lang="scss">
.lb-table-action-row {
  display: flex;
  align-items: center;

  height: rem-calc(60px);
  background-color: $lb-color-primary;
  color: #fff;

  padding: $global-padding / 1.6 $global-padding * 1.25;

  &__divider {
    width: 1px;
    background-color: #000;
    align-self: stretch;

    margin: 0 $global-margin * 1.25;
  }

  &__close {
    color: #fff;
    font-size: rem-calc(24px);

    margin-left: auto;
    @include rtl() {
      margin-right: auto;
      margin-left: 0;
    }
  }
}
</style>
